import trackPerformance from './trackPerformance';
import type WeapiEventPayload from './contracts/weapiEventPayload';

export { trackPerformance as default, WeapiEventPayload };
